<template lang="pug">
div.cellphoneModal
  modal-base(v-if="openModal" @toggle="toggleModal")
    div.cellphoneModal__content
      div.cellphoneModal__circles
        img(src="~@/assets/icons/circles.svg")
      div.cellphoneModal__image
        picture
          source(srcset="https://ciclic.imgix.net/jumper/success/banner-viagem-celular-mob.png?auto=format,compress" media="(max-width: 667px)")
          source(srcset="https://ciclic.imgix.net/jumper/success/banner-viagem-celular-tablet.png?auto=format,compress" media="(max-width: 1024px)")
          img(src="https://ciclic.imgix.net/jumper/success/banner-viagem-celular-desk.png?auto=format,compress", alt="Imagem de divulgação do Seguro Celular")
      div.cellphoneModal__text
        small.cellphoneModal__text__small Seguro Celular
        p.cellphoneModal__text__title Que tal proteger seu celular contra furto e quebra em sua viagem?
        a.cellphoneModal__text__link(href="/seguro-celular/#/?utm_source=site_ciclic&utm_medium=conversao_viagem&utm_campaign=cross_celular_modal_2022", target="_blank") Cotar agora
</template>

<script>
import modalBase from '@/components/ModalBase.vue'

export default {
  name: 'CellphoneModal',
  components: {
    modalBase
  },
  data () {
    return {
      openModal: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.openModal = true
    }, 2000)
  },
  methods: {
    toggleModal () {
      this.openModal = !this.openModal
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";
@import "~@/style/ui/sizes";

$hightlight-color: #72F951;
$secondary-hightlight-color: #088E82;
$darken-color: #323232;

.cellphoneModal {

  // overwrite ModalBase styles
  .modal-wrapper {
    .modal-container {
      position: relative;
      border-radius: 12.5px;

      @media #{$tablet-query} {
        border-radius: 16px;
      }

      img {
        display: block;
      }
    }

    .modal-close-button {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      margin: 0;
      width: 25px;
      height: 25px;
      margin: 8px;
    }
  }

  &__content {
    max-width: 520px;
    display: flex;
    align-items: center;

    @media #{$tablet-query} {
      max-width: 440px;
    }

    @media #{$mobile-query} {
      max-width: 320px;
      flex-direction: column;
    }
  }

  &__circles {
    position: absolute;
    bottom: 0;
    right: 0;

    @media #{$tablet-query} {
      max-width: 43px;
    }

    @media #{$mobile-query} {
      display: none;
    }
  }

  &__image,
  &__text {
    width: 50%;

    @media #{$mobile-query} {
      width: 100%;
    }
  }

  &__text {
    padding: 27px;
    font-family: $oscine-font-family;
    line-height: 0;

    @media #{$tablet-query} {
      padding: 22px;
    }

    @media #{$mobile-query} {
      padding: 21px 21px 29px;
    }

    &__small {
      font-size: 14px;
      line-height: 18px;
      color: $secondary-hightlight-color;
    }

    &__title {
      font-size: 24px;
      line-height: 31px;
      font-weight: 700;
      color: $darken-color;

      @media #{$tablet-query} {
        font-size: 20px;
        line-height: 26px;
      }

      @media #{$mobile-query} {
        font-size: 22px;
      }
    }

    &__link {
      background-color: $hightlight-color;
      font-size: 16px;
      line-height: 22px;
      padding: 9px 24px 11px;
      border-radius: 28px;
      color: $darken-color;
      white-space: nowrap;
      transition: 250ms ease-in-out all;
      display: inline-block;
      margin-top: 14px;

      @media #{$mobile-query} {
        text-align: center;
        width: 100%;
        margin-top: 22px;
      }

      &:hover {
        background-color: darken($hightlight-color, 7%);
      }
    }
  }
}
</style>
